import { useMemo } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export interface ChartTheme {
  grid: string;
  tick: string;
  tickSecondary: string;
  referenceLine: string;
  pieSeparator: string;
  cursorFill: string;
  cursorStroke: string;
}

const LIGHT: ChartTheme = {
  grid: '#f0f0f0',
  tick: '#9ca3af',
  tickSecondary: '#374151',
  referenceLine: '#d1d5db',
  pieSeparator: '#ffffff',
  cursorFill: 'rgba(0, 0, 0, 0.06)',
  cursorStroke: '#d1d5db',
};

const DARK: ChartTheme = {
  grid: '#27272a',
  tick: '#71717a',
  tickSecondary: '#d4d4d8',
  referenceLine: '#3f3f46',
  pieSeparator: '#18181b',
  cursorFill: 'rgba(255, 255, 255, 0.08)',
  cursorStroke: '#3f3f46',
};

export function useChartTheme(): ChartTheme {
  const { resolvedTheme } = useTheme();
  return useMemo(() => (resolvedTheme === 'dark' ? DARK : LIGHT), [resolvedTheme]);
}
